<template>
    <div class="question-example-phonetic-consonant">
        <span class="question-example-phonetic-consonant__label">ÖRNEK:</span>
        <span class="question-example-phonetic-consonant__example-phonemic">/ {{ examplePhonemic }} /</span>
        <span class="question-example-phonetic-consonant__separator">-></span>
        <span class="question-example-phonetic-consonant__example-phonetic">[ {{ examplePhonetic }} ]</span>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            examplePhonemic: { type: String, default: 'tek' },
            examplePhonetic: { type: String, default: 'tʰɛc' },
        }
    };
</script>

<style scoped src="@/css/components/question-example-phonetic-consonant.css"></style>